import describeDocument from "@/data/describe/mixins/describeDocument";

export default {
  mixins: [describeDocument],
  methods: {
    generateDocumentLogShortText(tag, verb) {
      let noun = this.defineDocumentFromTag(tag).title;
      let text = noun + " " + verb;
      return text;
    },
    genereateDocumentLogChangeText(char) {
      let noun = char.tnoun;
      let verb = char.tverb;
      let item = char.title;
      let text = noun + " " + item + " " + verb;
      return text;
    }
  }
};
